import React from 'react'
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { getUserStatusBadge } from '../../../resources/Utils';
import { Badge } from 'react-bootstrap';
import { regEx } from '../../../resources/Utils';

const Authorization = ({userInfo, disabled, onChange, onClickFindMerchant, action}) => {
    const statusBadge = getUserStatusBadge(userInfo.status);
    return (
        <React.Fragment>
            <Row>
                <Col sm={12} className="text-grey font-weight-bold">
                    User Profile
                </Col>
                </Row>
                <Row className="mt-3">
                <Col sm={12}>
                    <Row>
                    
                    <Col sm={6}>
                        <Form.Group controlId="merchantId">
                            <Form.Label className="text-grey font-weight-bold medium required">Merchant ID</Form.Label>
                            <Form.Control
                                name="merchantId" type="text" placeholder="Enter merchant ID"
                                pattern="\d{10}"
                                maxLength="10"
                                title="Merchant ID must be 10 digits only"
                                value={userInfo ? userInfo.merchantId : ''}
                                onChange={onChange}
                                form="merchantFindingForm"
                                disabled={true}
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group controlId="merchantName">
                        <Form.Label className="text-grey font-weight-bold medium">Merchant Name</Form.Label>
                        <Form.Control
                            name="merchantName" type="text"
                            placeholder="Merchant name"
                            disabled={true}
                            value={userInfo ? userInfo.merchantName : ''}
                        />
                        </Form.Group>
                    </Col>                          
                    </Row>
                    <Row>                            
                    <Col sm={6}>
                        <Form.Group controlId="username">
                        <Form.Label className="text-grey font-weight-bold medium required">Username (6-15 characters)</Form.Label>
                        <InputGroup>                                
                            <Form.Control
                            name="username" type="text"
                            placeholder="Enter username"
                            pattern="[A-Za-z0-9-_]{6,15}"
                            maxLength="15"
                            title="Username must be 6-15 alphanumerics (include '-', '_')"
                            value={userInfo ? userInfo.username : ''}
                            onChange={onChange}
                            required
                            disabled={disabled || action === 'update'}
                            />
                            {action !== 'create' &&                                  
                            <InputGroup.Append>
                            <InputGroup.Text className="border-left-0" > 
                                <Badge pill variant={statusBadge.style}>
                                    <small>{statusBadge.text}</small>
                                </Badge>
                            </InputGroup.Text>
                            </InputGroup.Append>                                  
                            }
                        </InputGroup>
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group controlId="fullName">
                        <Form.Label className="text-grey font-weight-bold medium required">Full Name</Form.Label>
                        <Form.Control
                            name="fullName" type="text"
                            placeholder="Enter firstname and lastname"
                            pattern="[A-Za-z\s\-.]{1,30}"
                            maxLength="30"
                            title="Full name must be A-Z,a-z,'-', '.', ' '"
                            value={userInfo ? userInfo.fullName : ''}
                            onChange={onChange}
                            required
                            disabled={disabled}
                        />
                        </Form.Group>
                    </Col>
                    </Row>
                    <Row>
                    <Col sm={6}>
                        <Form.Group controlId="email">
                        <Form.Label className="text-grey font-weight-bold medium required">Email</Form.Label>
                        <Form.Control
                            name="email" type="text"
                            placeholder="Enter email address"
                            pattern={regEx.EMAIL}
                            title="Email address is invalid format."
                            value={userInfo ? userInfo.email : ''}
                            onChange={onChange}
                            required
                            disabled={disabled || action === 'update'}
                        />
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group controlId="contactNumber">
                        <Form.Label className="text-grey font-weight-bold medium">Contact Number</Form.Label>
                        <Form.Control
                            name="contactNumber" type="text"
                            placeholder="Enter contact number"
                            pattern='[0-9]{9,10}'
                            maxLength="10"
                            title="Contact number must be less than or equal to 10 digits"
                            value={userInfo ? userInfo.contactNumber : ''}
                            onChange={onChange}
                            disabled={disabled}
                        />
                        </Form.Group>
                    </Col>
                    </Row>
                    <Row>
                    <Col sm={6}>
                        <Form.Group controlId="note">
                        <Form.Label className="text-grey font-weight-bold medium">Note</Form.Label>
                        <Form.Control as="textarea"
                            name="note" type="text"
                            placeholder="Enter note"
                            maxLength="255"
                            value={userInfo ? userInfo.note : ''}
                            onChange={onChange}
                            disabled={disabled}
                        />
                        </Form.Group>
                    </Col>
                    </Row>
                </Col>
                </Row>
        </React.Fragment>
    )
}

export default Authorization
